export default __webpack_public_path__ + "static/SRF Carasweet 5S7303BIO - Fiche de spécifications et données techniques-cc2d087b27ade9c52daafbfc5dd9799a.pdf";